import React from "react";
import Navbar from "../components/sub-comp/Navbar.jsx";
import Footer from "../components/sub-comp/MainFooter.jsx";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";

const DataAnalysisServices = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="mid-desktop-page">

      <section className="py-16 bg-gradient-to-r from-custom-pink to-purple-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">
            Data Analysis Services
          </h1>
          <p className="text-lg sm:text-xl max-w-3xl mx-auto mb-6">
            Professional data analysis support for the JR Institute community.
          </p>
        </div>
      </section>

      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            How We Can Help
          </h2>
          <p className="text-gray-700 mb-4">
            The Data Analysis Services team can assist with basic reporting,
            dashboards, and simple insight generation using existing school
            data. This is intentionally kept straightforward so it is easy to
            manage.
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-2 mb-8">
            <li>Simple dashboards and summary reports</li>
            <li>Basic charts and visualizations for presentations</li>
            <li>Support for student or departmental projects</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-800 mb-3">
            Get in Touch
          </h3>
          <p className="text-gray-700 mb-6">
            To request support, use the contact page and briefly describe
            what kind of data or questions you have. The team can then follow
            up with you directly.
          </p>

          <a
            href="/contact"
            className="inline-block bg-custom-pink text-white px-6 py-3 rounded-lg font-semibold hover:bg-gold transition-colors duration-300"
          >
            Request Data Support
          </a>
        </div>
      </section>

      </div>

      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default DataAnalysisServices;


